import React from "react";
import cn from 'classnames';
import DatePickerCalendar from 'championship/src/fork/ReactModernCalandarDatepicker';
import {russian} from "../../classes/helpers/calendar-location";
import {ReactComponent as ChevronLeft} from 'championship/static/championship/icon/feather/chevron-left.svg'
import {ReactComponent as ChevronRight} from 'championship/static/championship/icon/feather/chevron-right.svg'
import {ReactComponent as Calendar} from 'championship/static/championship/icon/feather/calendar.svg'
import 'championship/src/fork/ReactModernCalandarDatepicker/DatePicker.css';
import './style.css';

function toValue(date) {
  if (!date) return undefined
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate()
  }
}

function toDate(value) {
  if (!value) return undefined
  return new Date(value.year, value.month - 1, value.day)
}

function defaultFormatDisplay(dateInput, locale = 'ru-RU') {
  if (!dateInput) return ''
  const date = new Date(dateInput);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');

  const weekday = new Intl.DateTimeFormat(locale, {weekday: 'short'}).format(date);

  return `${day}.${month} ${weekday}`;
}

export function renderInputDateStepper({value, onChange, formatDisplay = defaultFormatDisplay}) {
  function shiftDayClick(shift) {
    return () => {
      const newDate = new Date(value)
      newDate.setDate(value.getDate() + shift);
      onChange(newDate)
    }
  }

  return ({ref}) => {
    return (
      <div className="date-picker">
        {value && (
          <div className="date-picker__addon date-picker__icon text-hover" onClick={shiftDayClick(-1)}>
            <ChevronLeft/>
          </div>
        )}
        <div className={cn('date-picker__value text-hover', {
          'date-picker__placeholder': !value,
        })} tabIndex="0">
          <input type="text" ref={ref} readOnly/>
          <div className="date-picker__icon" style={{marginRight: 4}}>
            <Calendar/>
          </div>
          {value ? formatDisplay(value) : gettext('Выберите дату')}
        </div>
        {value && (
          <div className="date-picker__addon date-picker__icon text-hover" onClick={shiftDayClick(1)}>
            <ChevronRight/>
          </div>
        )}
      </div>
    )
  }
}

function DatePicker(props) {
  return (
    <DatePickerCalendar
      value={toValue(props.value)}
      onChange={(value) => props.onChange(toDate(value))}
      wrapperClassName={props.className}
      calendarClassName='date-picker__popup'
      shouldHighlightWeekends
      colorPrimary="#FF2424"
      colorPrimaryLight="#FF242433"
      // maximumDate={props.max}
      locale={russian}
      renderInput={props.renderInput(props)}
    />)
}

export default DatePicker